module.exports = __webpack_public_path__ + "Fonts/lato-regular-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./app/Style/fonts/lato/lato-regular-webfont.svg
// module id = 369
// module chunks = 4